import React, { useState, useEffect } from 'react';
import Login from './Login';
import Chat from './Chat';
import Footer from './Footer';

const API_URL = "https://api.kolqo.com";

function App() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('token');
    if (saved) setToken(saved);
  }, []);

  const handleLogin = (newToken) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return (
    <div className="app-wrapper">
      <div className="main-content">
        {!token ? (
          <Login apiUrl={API_URL} onLogin={handleLogin} />
        ) : (
          <Chat apiUrl={API_URL} token={token} onLogout={handleLogout} />
        )}
      </div>
      <Footer />
    </div>
  );
}

export default App;